import Super from './document-request';
import classic from 'ember-classic-decorator';

@classic
export default class DocumentRequestConsentDocument extends Super {}
